/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePartRequestDto
 */
export interface CreatePartRequestDto {
    /**
     * Unique stable code for the part
     * @type {string}
     * @memberof CreatePartRequestDto
     */
    code: string;
    /**
     * Display label
     * @type {string}
     * @memberof CreatePartRequestDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePartRequestDto
     */
    manufacturer: string;
    /**
     * Serialized unit tracking, when applicable
     * @type {string}
     * @memberof CreatePartRequestDto
     */
    serialNumber?: string | null;
    /**
     * Flexible bag for type-specific attributes (rating, size, SKU, …)
     * @type {{ [key: string]: any; }}
     * @memberof CreatePartRequestDto
     */
    properties?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the CreatePartRequestDto interface.
 */
export function instanceOfCreatePartRequestDto(value: object): value is CreatePartRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('manufacturer' in value) || value['manufacturer'] === undefined) return false;
    return true;
}

export function CreatePartRequestDtoFromJSON(json: any): CreatePartRequestDto {
    return CreatePartRequestDtoFromJSONTyped(json, false);
}

export function CreatePartRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePartRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'manufacturer': json['manufacturer'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'properties': json['properties'] == null ? undefined : json['properties'],
    };
}

export function CreatePartRequestDtoToJSON(json: any): CreatePartRequestDto {
    return CreatePartRequestDtoToJSONTyped(json, false);
}

export function CreatePartRequestDtoToJSONTyped(value?: CreatePartRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'manufacturer': value['manufacturer'],
        'serialNumber': value['serialNumber'],
        'properties': value['properties'],
    };
}

